import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap/dist/js/bootstrap.js'
import 'bootstrap-icons/font/bootstrap-icons.css'
import '../node_modules/rpg-awesome/scss/rpg-awesome.scss'
import './assets/styles/theme.css'
import './assets/styles/global.css'
import store from './store';
import { initFoldback } from './foldback';

createApp(App)
  .use(store)
  .use(router)
  .mount('#app')

// In-app feedback. No-op unless the user enabled it in Settings, or the
// URL carries ?foldback=enabled.
initFoldback();
